// Zähler im Raum (Handoff §4.2): Symbol nach Art, „Art · Nummer“, Stand-Feld, Foto-Knopf
// (grün mit Haken, sobald ein Foto da ist). Ablauf wie bisher: ein Foto je Zähler.
import React from 'react';
import { Camera, Check } from '@phosphor-icons/react';
import FotoVorschau from './FotoVorschau';
import { zaehlerStil } from '../../../lib/uebergabeAnsicht/darstellung';
import { ZAEHLER_ICON, istTouch, schriftAuf } from './assistent/Rundgangteile';

interface ZaehlerZeileProps {
  art: string;
  nummer: string;
  stand: string;
  foto: string | null;
  fotos: Record<string, Blob>;
  standAendern: (stand: string) => void;
  fotoHinzufuegen: (datei: File) => void;
}

const ZaehlerZeile: React.FC<ZaehlerZeileProps> = ({ art, nummer, stand, foto, fotos, standAendern, fotoHinzufuegen }) => {
  const stil = zaehlerStil(art);
  const I = ZAEHLER_ICON[stil.symbol];
  const hatFoto = !!(foto && fotos[foto]);
  const h = istTouch() ? 46 : 42;
  return (
    <div className="flex flex-wrap items-center" style={{ gap: 10, padding: 10, borderRadius: 16, background: 'var(--fill)', boxShadow: stand.trim() ? 'inset 0 0 0 2px var(--ok)' : 'inset 0 0 0 1px var(--line)' }}>
      <span aria-hidden className="inline-flex shrink-0 items-center justify-center" style={{ width: 34, height: 34, borderRadius: 10, background: stil.farbe, color: schriftAuf(stil.farbe) }}>
        <I size={17} weight="fill" />
      </span>
      <span className="min-w-0 flex-1 truncate" style={{ fontSize: 13.5, fontWeight: 800, flexBasis: 120 }}>{art} · <span style={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', fontWeight: 700 }}>{nummer}</span></span>
      <span className="flex items-center" style={{ gap: 8 }}>
        <input inputMode="numeric" value={stand} onChange={e => standAendern(e.target.value)} placeholder="Stand" aria-label={`Stand ${art} ${nummer}`}
          style={{ width: 120, height: h, padding: '0 12px', borderRadius: 12, border: 'none', outline: 'none', background: 'var(--bg)', boxShadow: 'inset 0 0 0 1px var(--line)',
            fontFamily: 'inherit', fontSize: 16, fontWeight: 800, textAlign: 'right', color: 'var(--ink)' }} />
        {hatFoto && <FotoVorschau blob={fotos[foto!]} groesse={h} />}
        <label data-tip="Foto vom Zählerstand" className="relative inline-flex shrink-0 cursor-pointer items-center justify-center"
          style={{ width: h, height: h, borderRadius: 12, background: hatFoto ? 'var(--ok)' : 'var(--fill2)', color: hatFoto ? '#fff' : 'var(--ink2)' }}>
          {hatFoto ? <Check size={16} weight="bold" /> : <Camera size={17} weight="fill" />}
          <input type="file" accept="image/*" capture="environment" className="hidden" aria-label="Foto vom Zählerstand"
            onChange={e => { const datei = e.target.files?.[0]; if (datei) fotoHinzufuegen(datei); e.target.value = ''; }} />
        </label>
      </span>
    </div>
  );
};

export default ZaehlerZeile;
